var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "role"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "col-md-12 mb-2"
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('h5', [_c('i', {
    staticClass: "fa fa-dashboard"
  }), _vm._v(" Dashboard")])]), _vm._v(" "), _c('div', {
    staticClass: "card-body1"
  }, [_c('form', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Manifest Date (From)")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-calendar'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "date"
    },
    model: {
      value: (_vm.manifestFromDate),
      callback: function($$v) {
        _vm.manifestFromDate = $$v
      },
      expression: "manifestFromDate"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Manifest Date (To)")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-calendar'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "date"
    },
    model: {
      value: (_vm.manifestToDate),
      callback: function($$v) {
        _vm.manifestToDate = $$v
      },
      expression: "manifestToDate"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Investigate Status :")]), _vm._v(" "), _c('b-form-select', {
    attrs: {
      "options": [{
          value: 'open',
          text: 'Open'
        },
        {
          value: 'close',
          text: 'Close'
        }
      ]
    },
    model: {
      value: (_vm.investigationStatus),
      callback: function($$v) {
        _vm.investigationStatus = $$v
      },
      expression: "investigationStatus"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Investigation Logged Date (From):")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-calendar'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "date"
    },
    model: {
      value: (_vm.fromdate),
      callback: function($$v) {
        _vm.fromdate = $$v
      },
      expression: "fromdate"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "text-danger",
    attrs: {
      "id": "fdate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Investigation Logged Date (To):")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-calendar'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "date"
    },
    model: {
      value: (_vm.todate),
      callback: function($$v) {
        _vm.todate = $$v
      },
      expression: "todate"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.searchDashboard()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v("\n                Search")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": function($event) {
        _vm.resetForm()
      }
    }
  }, [_vm._v(" Reset "), _c('i', {
    staticClass: "fa fa-refresh"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-primary salesDemoRemove",
    on: {
      "click": function($event) {
        _vm.removeSalesDemo()
      }
    }
  }, [_vm._v("\n                Remove Test/QA shipments "), _c('i', {
    staticClass: "fa fa-trash-o"
  })])])])])])], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [(_vm.hasSearched) ? _c('div', {
    staticClass: "table-responsive"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "textAlign"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [(_vm.shipmentCLT.length == 0) ? _c('tr', [_c('td', {
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "align": "center",
      "colspan": "11"
    }
  }, [_vm._v("No Record Found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.shipmentCLT), function(x) {
    return _c('tr', [_c('th', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(x.hubzonename ? x.hubzonename : '-'))]), _vm._v(" "), (x.dispute > 0) ? _c('td', {
      staticClass: "csv",
      on: {
        "click": function($event) {
          _vm.exportDataCSV(x.hubzoneid, '2', 12)
        }
      }
    }, [_vm._v(_vm._s(x.dispute) + " ")]) : _c('td', [_vm._v(_vm._s(x.dispute ? x.dispute : '0') + "  ")]), _vm._v(" "), (x.dtodispute > 0) ? _c('td', {
      staticClass: "csv",
      on: {
        "click": function($event) {
          _vm.exportDataCSV(x.hubzoneid, '2', 19)
        }
      }
    }, [_vm._v(_vm._s(x.dtodispute) + " ")]) : _c('td', [_vm._v(_vm._s(x.dtodispute ? x.dtodispute : '0') + " ")]), _vm._v(" "), (x.rtodispute > 0) ? _c('td', {
      staticClass: "csv",
      on: {
        "click": function($event) {
          _vm.exportDataCSV(x.hubzoneid, '2', 13)
        }
      }
    }, [_vm._v(_vm._s(x.rtodispute) + " ")]) : _c('td', [_vm._v(_vm._s(x.rtodispute ? x.rtodispute : '0') + " ")]), _vm._v(" "), (x.whhandoverdispute > 0) ? _c('td', {
      staticClass: "csv",
      on: {
        "click": function($event) {
          _vm.exportDataCSV(x.hubzoneid, '2', 20)
        }
      }
    }, [_vm._v(_vm._s(x.whhandoverdispute) + " ")]) : _c('td', [_vm._v(_vm._s(x.whhandoverdispute ? x.whhandoverdispute : '0'))]), _vm._v(" "), (x.forwarddispute > 0) ? _c('td', {
      staticClass: "csv",
      on: {
        "click": function($event) {
          _vm.exportDataCSV(x.hubzoneid, '2', 17)
        }
      }
    }, [_vm._v(_vm._s(x.forwarddispute) + " ")]) : _c('td', [_vm._v(_vm._s(x.forwarddispute ? x.forwarddispute : '0') + " ")]), _vm._v(" "), (x.shortage > 0) ? _c('td', {
      staticClass: "csv",
      on: {
        "click": function($event) {
          _vm.exportDataCSV(x.hubzoneid, '2', 11)
        }
      }
    }, [_vm._v(_vm._s(x.shortage) + " ")]) : _c('td', [_vm._v(_vm._s(x.shortage ? x.shortage : '0') + " ")]), _vm._v(" "), (x.std > 0) ? _c('td', {
      staticClass: "csv",
      on: {
        "click": function($event) {
          _vm.exportDataCSV(x.hubzoneid, '2', 1)
        }
      }
    }, [_vm._v(_vm._s(x.std) + " ")]) : _c('td', [_vm._v(_vm._s(x.std ? x.std : '0') + " ")]), _vm._v(" "), (x.clientdebit > 0) ? _c('td', {
      staticClass: "csv",
      on: {
        "click": function($event) {
          _vm.exportDataCSV(x.hubzoneid, '2', 21)
        }
      }
    }, [_vm._v(_vm._s(x.clientdebit) + " ")]) : _c('td', [_vm._v(_vm._s(x.clientdebit ? x.clientdebit : '0') + " ")]), _vm._v(" "), (x.forcefullylost > 0) ? _c('td', {
      staticClass: "csv",
      on: {
        "click": function($event) {
          _vm.exportDataCSV(x.hubzoneid, '2', 15)
        }
      }
    }, [_vm._v(_vm._s(x.forcefullylost) + " ")]) : _c('td', [_vm._v(_vm._s(x.forcefullylost ? x.forcefullylost : '0') + " ")]), _vm._v(" "), (x.forcefullylost_rto > 0) ? _c('td', {
      staticClass: "csv",
      on: {
        "click": function($event) {
          _vm.exportDataCSV(x.hubzoneid, '2', 16)
        }
      }
    }, [_vm._v(_vm._s(x.forcefullylost_rto) + " ")]) : _c('td', [_vm._v(_vm._s(x.forcefullylost_rto ? x.forcefullylost_rto : '0') + " ")]), _vm._v(" "), (x.nts > 0) ? _c('td', {
      staticClass: "csv",
      on: {
        "click": function($event) {
          _vm.exportDataCSV(x.hubzoneid, '2', 18)
        }
      }
    }, [_vm._v(_vm._s(x.nts) + " ")]) : _c('td', [_vm._v(_vm._s(x.nts) + " ")]), _vm._v(" "), (x.totalshippingid > 0) ? _c('td', {
      staticClass: "csv",
      on: {
        "click": function($event) {
          _vm.exportDataCSV(x.hubzoneid, '2')
        }
      }
    }, [_vm._v(_vm._s(x.totalshippingid) + " ")]) : _c('td', [_vm._v(_vm._s(x.totalshippingid ? x.totalshippingid : '0') + " ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(x.declaredvalue ? x.declaredvalue : '0'))])])
  })], 2)])])]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [(_vm.hasSearched) ? _c('div', {
    staticClass: "table-responsive"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "textAlign"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped"
  }, [_vm._m(3), _vm._v(" "), _c('tbody', [(_vm.shipmentOperation.length == 0) ? _c('tr', [_c('td', {
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "align": "center",
      "colspan": "11"
    }
  }, [_vm._v("No Record Found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.shipmentOperation), function(x) {
    return _c('tr', [_c('th', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(x.hubzonename ? x.hubzonename : '-'))]), _vm._v(" "), (x.dispute > 0) ? _c('td', {
      staticClass: "csv",
      on: {
        "click": function($event) {
          _vm.exportDataCSV(x.hubzoneid, '1', 12)
        }
      }
    }, [_vm._v(_vm._s(x.dispute) + " ")]) : _c('td', [_vm._v(_vm._s(x.dispute ? x.dispute : '0') + "  ")]), _vm._v(" "), (x.dtodispute > 0) ? _c('td', {
      staticClass: "csv",
      on: {
        "click": function($event) {
          _vm.exportDataCSV(x.hubzoneid, '1', 19)
        }
      }
    }, [_vm._v(_vm._s(x.dtodispute) + " ")]) : _c('td', [_vm._v(_vm._s(x.dtodispute ? x.dtodispute : '0') + " ")]), _vm._v(" "), (x.rtodispute > 0) ? _c('td', {
      staticClass: "csv",
      on: {
        "click": function($event) {
          _vm.exportDataCSV(x.hubzoneid, '1', 13)
        }
      }
    }, [_vm._v(_vm._s(x.rtodispute) + " ")]) : _c('td', [_vm._v(_vm._s(x.rtodispute ? x.rtodispute : '0') + " ")]), _vm._v(" "), (x.whhandoverdispute > 0) ? _c('td', {
      staticClass: "csv",
      on: {
        "click": function($event) {
          _vm.exportDataCSV(x.hubzoneid, '1', 20)
        }
      }
    }, [_vm._v(_vm._s(x.whhandoverdispute) + " ")]) : _c('td', [_vm._v(_vm._s(x.whhandoverdispute ? x.whhandoverdispute : '0') + " ")]), _vm._v(" "), (x.forwarddispute > 0) ? _c('td', {
      staticClass: "csv",
      on: {
        "click": function($event) {
          _vm.exportDataCSV(x.hubzoneid, '1', 17)
        }
      }
    }, [_vm._v(_vm._s(x.forwarddispute) + " ")]) : _c('td', [_vm._v(_vm._s(x.forwarddispute ? x.forwarddispute : '0') + " ")]), _vm._v(" "), (x.shortage > 0) ? _c('td', {
      staticClass: "csv",
      on: {
        "click": function($event) {
          _vm.exportDataCSV(x.hubzoneid, '1', 11)
        }
      }
    }, [_vm._v(_vm._s(x.shortage) + " ")]) : _c('td', [_vm._v(_vm._s(x.shortage ? x.shortage : '0') + " ")]), _vm._v(" "), (x.std > 0) ? _c('td', {
      staticClass: "csv",
      on: {
        "click": function($event) {
          _vm.exportDataCSV(x.hubzoneid, '1', 1)
        }
      }
    }, [_vm._v(_vm._s(x.std) + " ")]) : _c('td', [_vm._v(_vm._s(x.std ? x.std : '0') + " ")]), _vm._v(" "), (x.clientdebit > 0) ? _c('td', {
      staticClass: "csv",
      on: {
        "click": function($event) {
          _vm.exportDataCSV(x.hubzoneid, '1', 21)
        }
      }
    }, [_vm._v(_vm._s(x.clientdebit) + " ")]) : _c('td', [_vm._v(_vm._s(x.clientdebit ? x.clientdebit : '0') + " ")]), _vm._v(" "), (x.forcefullylost > 0) ? _c('td', {
      staticClass: "csv",
      on: {
        "click": function($event) {
          _vm.exportDataCSV(x.hubzoneid, '1', 15)
        }
      }
    }, [_vm._v(_vm._s(x.forcefullylost) + " ")]) : _c('td', [_vm._v(_vm._s(x.forcefullylost ? x.forcefullylost : '0') + " ")]), _vm._v(" "), (x.forcefullylost_rto > 0) ? _c('td', {
      staticClass: "csv",
      on: {
        "click": function($event) {
          _vm.exportDataCSV(x.hubzoneid, '1', 16)
        }
      }
    }, [_vm._v(_vm._s(x.forcefullylost_rto) + " ")]) : _c('td', [_vm._v(_vm._s(x.forcefullylost_rto ? x.forcefullylost_rto : '0') + " ")]), _vm._v(" "), (x.nts > 0) ? _c('td', {
      staticClass: "csv",
      on: {
        "click": function($event) {
          _vm.exportDataCSV(x.hubzoneid, '1', 18)
        }
      }
    }, [_vm._v(_vm._s(x.nts) + " ")]) : _c('td', [_vm._v(_vm._s(x.nts) + " ")]), _vm._v(" "), (x.totalshippingid > 0) ? _c('td', {
      staticClass: "csv",
      on: {
        "click": function($event) {
          _vm.exportDataCSV(x.hubzoneid, '1')
        }
      }
    }, [_vm._v(_vm._s(x.totalshippingid) + " ")]) : _c('td', [_vm._v(_vm._s(x.totalshippingid ? x.totalshippingid : '0') + " ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(x.declaredvalue ? x.declaredvalue : '0'))])])
  })], 2)])])]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [(_vm.hasSearched) ? _c('div', {
    staticClass: "table-responsive"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "textAlign"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped"
  }, [_vm._m(5), _vm._v(" "), _c('tbody', [(_vm.shipmentSecurity.length == 0) ? _c('tr', [_c('td', {
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "align": "center",
      "colspan": "11"
    }
  }, [_vm._v("No Record Found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.shipmentSecurity), function(x) {
    return _c('tr', [_c('th', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(x.hubzonename ? x.hubzonename : '-'))]), _vm._v(" "), (x.dispute > 0) ? _c('td', {
      staticClass: "csv",
      on: {
        "click": function($event) {
          _vm.exportDataCSV(x.hubzoneid, '3', 12)
        }
      }
    }, [_vm._v(_vm._s(x.dispute) + " ")]) : _c('td', [_vm._v(_vm._s(x.dispute ? x.dispute : '0') + " ")]), _vm._v(" "), (x.dtodispute > 0) ? _c('td', {
      staticClass: "csv",
      on: {
        "click": function($event) {
          _vm.exportDataCSV(x.hubzoneid, '3', 19)
        }
      }
    }, [_vm._v(_vm._s(x.dtodispute) + " ")]) : _c('td', [_vm._v(_vm._s(x.dtodispute ? x.dtodispute : '0') + " ")]), _vm._v(" "), (x.rtodispute > 0) ? _c('td', {
      staticClass: "csv",
      on: {
        "click": function($event) {
          _vm.exportDataCSV(x.hubzoneid, '3', 13)
        }
      }
    }, [_vm._v(_vm._s(x.rtodispute) + " ")]) : _c('td', [_vm._v(_vm._s(x.rtodispute ? x.rtodispute : '0') + " ")]), _vm._v(" "), (x.whhandoverdispute > 0) ? _c('td', {
      staticClass: "csv",
      on: {
        "click": function($event) {
          _vm.exportDataCSV(x.hubzoneid, '3', 20)
        }
      }
    }, [_vm._v(_vm._s(x.whhandoverdispute) + " ")]) : _c('td', [_vm._v(_vm._s(x.whhandoverdispute ? x.whhandoverdispute : '0') + " ")]), _vm._v(" "), (x.forwarddispute > 0) ? _c('td', {
      staticClass: "csv",
      on: {
        "click": function($event) {
          _vm.exportDataCSV(x.hubzoneid, '3', 17)
        }
      }
    }, [_vm._v(_vm._s(x.forwarddispute) + " ")]) : _c('td', [_vm._v(_vm._s(x.forwarddispute ? x.forwarddispute : '0') + " ")]), _vm._v(" "), (x.shortage > 0) ? _c('td', {
      staticClass: "csv",
      on: {
        "click": function($event) {
          _vm.exportDataCSV(x.hubzoneid, '3', 11)
        }
      }
    }, [_vm._v(_vm._s(x.shortage) + " ")]) : _c('td', [_vm._v(_vm._s(x.shortage ? x.shortage : '0') + " ")]), _vm._v(" "), (x.std > 0) ? _c('td', {
      staticClass: "csv",
      on: {
        "click": function($event) {
          _vm.exportDataCSV(x.hubzoneid, '3', 1)
        }
      }
    }, [_vm._v(_vm._s(x.std) + " ")]) : _c('td', [_vm._v(_vm._s(x.std ? x.std : '0') + " ")]), _vm._v(" "), (x.clientdebit > 0) ? _c('td', {
      staticClass: "csv",
      on: {
        "click": function($event) {
          _vm.exportDataCSV(x.hubzoneid, '3', 21)
        }
      }
    }, [_vm._v(_vm._s(x.clientdebit) + " ")]) : _c('td', [_vm._v(_vm._s(x.clientdebit ? x.clientdebit : '0') + " ")]), _vm._v(" "), (x.forcefullylost > 0) ? _c('td', {
      staticClass: "csv",
      on: {
        "click": function($event) {
          _vm.exportDataCSV(x.hubzoneid, '3', 15)
        }
      }
    }, [_vm._v(_vm._s(x.forcefullylost) + " ")]) : _c('td', [_vm._v(_vm._s(x.forcefullylost ? x.forcefullylost : '0') + " ")]), _vm._v(" "), (x.forcefullylost_rto > 0) ? _c('td', {
      staticClass: "csv",
      on: {
        "click": function($event) {
          _vm.exportDataCSV(x.hubzoneid, '3', 16)
        }
      }
    }, [_vm._v(_vm._s(x.forcefullylost_rto) + " ")]) : _c('td', [_vm._v(_vm._s(x.forcefullylost_rto ? x.forcefullylost_rto : '0') + " ")]), _vm._v(" "), (x.nts > 0) ? _c('td', {
      staticClass: "csv",
      on: {
        "click": function($event) {
          _vm.exportDataCSV(x.hubzoneid, '3', 18)
        }
      }
    }, [_vm._v(_vm._s(x.nts) + " ")]) : _c('td', [_vm._v(_vm._s(x.nts ? x.nts : '0') + " ")]), _vm._v(" "), (x.totalshippingid > 0) ? _c('td', {
      staticClass: "csv",
      on: {
        "click": function($event) {
          _vm.exportDataCSV(x.hubzoneid, '3')
        }
      }
    }, [_vm._v(_vm._s(x.totalshippingid) + " ")]) : _c('td', [_vm._v(_vm._s(x.totalshippingid ? x.totalshippingid : '0') + " ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(x.declaredvalue ? x.declaredvalue : '0'))])])
  })], 2)])])]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [(_vm.hasSearched) ? _c('div', {
    staticClass: "table-responsive"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "textAlign"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped"
  }, [_vm._m(7), _vm._v(" "), _c('tbody', [(_vm.shipmentFinance.length == 0) ? _c('tr', [_c('td', {
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "align": "center",
      "colspan": "11"
    }
  }, [_vm._v("No Record Found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.shipmentFinance), function(x) {
    return _c('tr', [_c('th', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(x.hubzonename ? x.hubzonename : '-'))]), _vm._v(" "), (x.dispute > 0) ? _c('td', {
      staticClass: "csv",
      on: {
        "click": function($event) {
          _vm.exportDataCSV(x.hubzoneid, '4', 12)
        }
      }
    }, [_vm._v(_vm._s(x.dispute) + " ")]) : _c('td', [_vm._v(_vm._s(x.dispute ? x.dispute : '0') + " ")]), _vm._v(" "), (x.dtodispute > 0) ? _c('td', {
      staticClass: "csv",
      on: {
        "click": function($event) {
          _vm.exportDataCSV(x.hubzoneid, '4', 18)
        }
      }
    }, [_vm._v(_vm._s(x.dtodispute) + " ")]) : _c('td', [_vm._v(_vm._s(x.dtodispute ? x.dtodispute : '0') + " ")]), _vm._v(" "), (x.rtodispute > 0) ? _c('td', {
      staticClass: "csv",
      on: {
        "click": function($event) {
          _vm.exportDataCSV(x.hubzoneid, '4', 13)
        }
      }
    }, [_vm._v(_vm._s(x.rtodispute) + " ")]) : _c('td', [_vm._v(_vm._s(x.rtodispute ? x.rtodispute : '0') + " ")]), _vm._v(" "), (x.whhandoverdispute > 0) ? _c('td', {
      staticClass: "csv",
      on: {
        "click": function($event) {
          _vm.exportDataCSV(x.hubzoneid, '4', 20)
        }
      }
    }, [_vm._v(_vm._s(x.whhandoverdispute) + " ")]) : _c('td', [_vm._v(_vm._s(x.whhandoverdispute ? x.whhandoverdispute : '0') + " ")]), _vm._v(" "), (x.forwarddispute > 0) ? _c('td', {
      staticClass: "csv",
      on: {
        "click": function($event) {
          _vm.exportDataCSV(x.hubzoneid, '4', 17)
        }
      }
    }, [_vm._v(_vm._s(x.forwarddispute) + " ")]) : _c('td', [_vm._v(_vm._s(x.forwarddispute ? x.forwarddispute : '0') + " ")]), _vm._v(" "), (x.shortage > 0) ? _c('td', {
      staticClass: "csv",
      on: {
        "click": function($event) {
          _vm.exportDataCSV(x.hubzoneid, '4', 11)
        }
      }
    }, [_vm._v(_vm._s(x.shortage) + " ")]) : _c('td', [_vm._v(_vm._s(x.shortage ? x.shortage : '0') + " ")]), _vm._v(" "), (x.std > 0) ? _c('td', {
      staticClass: "csv",
      on: {
        "click": function($event) {
          _vm.exportDataCSV(x.hubzoneid, '4', 1)
        }
      }
    }, [_vm._v(_vm._s(x.std) + " ")]) : _c('td', [_vm._v(_vm._s(x.std ? x.std : '0') + " ")]), _vm._v(" "), (x.clientdebit > 0) ? _c('td', {
      staticClass: "csv",
      on: {
        "click": function($event) {
          _vm.exportDataCSV(x.hubzoneid, '4', 21)
        }
      }
    }, [_vm._v(_vm._s(x.clientdebit) + " ")]) : _c('td', [_vm._v(_vm._s(x.clientdebit ? x.clientdebit : '0') + " ")]), _vm._v(" "), (x.forcefullylost > 0) ? _c('td', {
      staticClass: "csv",
      on: {
        "click": function($event) {
          _vm.exportDataCSV(x.hubzoneid, '4', 15)
        }
      }
    }, [_vm._v(_vm._s(x.forcefullylost) + " ")]) : _c('td', [_vm._v(_vm._s(x.forcefullylost ? x.forcefullylost : '0') + " ")]), _vm._v(" "), (x.forcefullylost_rto > 0) ? _c('td', {
      staticClass: "csv",
      on: {
        "click": function($event) {
          _vm.exportDataCSV(x.hubzoneid, '4', 16)
        }
      }
    }, [_vm._v(_vm._s(x.forcefullylost_rto) + " ")]) : _c('td', [_vm._v(_vm._s(x.forcefullylost_rto ? x.forcefullylost_rto : '0') + " ")]), _vm._v(" "), (x.nts > 0) ? _c('td', {
      staticClass: "csv",
      on: {
        "click": function($event) {
          _vm.exportDataCSV(x.hubzoneid, '4', 18)
        }
      }
    }, [_vm._v(_vm._s(x.nts) + " ")]) : _c('td', [_vm._v(_vm._s(x.nts ? x.nts : '0') + " ")]), _vm._v(" "), (x.totalshippingid > 0) ? _c('td', {
      staticClass: "csv",
      on: {
        "click": function($event) {
          _vm.exportDataCSV(x.hubzoneid, '4')
        }
      }
    }, [_vm._v(_vm._s(x.totalshippingid) + " ")]) : _c('td', [_vm._v(_vm._s(x.totalshippingid ? x.totalshippingid : '0') + " ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(x.declaredvalue ? x.declaredvalue : '0'))])])
  })], 2)])])]) : _vm._e()]), _vm._v(" "), (_vm.loadingResult) ? _c('div', {
    staticClass: "download-loader-label"
  }, [_c('i', {
    staticClass: "fa fa-download",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n    Downloading count CSV...\n  ")]) : _vm._e(), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "active": _vm.loadingResult,
      "duration": "0.6",
      "spinner": "bar-fade-scale",
      "color": "#FF0000"
    }
  })], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_c('i', {
    staticClass: "fa fa-dashboard"
  }), _vm._v(" Investigation Pending Shipments Summary : CLT")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Region")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Dispute")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("DTO Dispute ")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("RTO Dispute ")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("WHHandover Dispute ")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Forward Dispute ")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Shortage")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("STD")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("ClientDebit")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Forcefully Lost ")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Forcefully RTO")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("NTS ")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Total Shipments ")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "Octroi MRP"
    }
  }, [_vm._v("Octroi MRP")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_c('i', {
    staticClass: "fa fa-dashboard"
  }), _vm._v(" Investigation Pending Shipments Summary : Operation")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Region")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Dispute")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("DTO Dispute ")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("RTO Dispute ")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("WHHandover Dispute ")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Forward Dispute ")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Shortage")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("STD")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("ClientDebit")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Forcefully Lost ")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Forcefully RTO")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("NTS ")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Total Shipments ")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "Octroi MRP"
    }
  }, [_vm._v("Octroi MRP")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_c('i', {
    staticClass: "fa fa-dashboard"
  }), _vm._v(" Investigation Pending Shipments Summary : Security")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Region")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Dispute")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("DTO Dispute ")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("RTO Dispute ")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("WHHandover Dispute ")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Forward Dispute ")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Shortage")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("STD")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("ClientDebit")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Forcefully Lost ")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Forcefully RTO")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("NTS ")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Total Shipments ")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "Octroi MRP"
    }
  }, [_vm._v("Octroi MRP")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_c('i', {
    staticClass: "fa fa-dashboard"
  }), _vm._v(" Investigation Pending Shipments Summary : Finance")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Region")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Dispute")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("DTO Dispute ")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("RTO Dispute ")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("WHHandover Dispute ")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Forward Dispute ")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Shortage")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("STD")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("ClientDebit")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Forcefully Lost ")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Forcefully RTO")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("NTS ")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Total Shipments ")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "Octroi MRP"
    }
  }, [_vm._v("Octroi MRP")])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ece2d34","hasScoped":true}!./src/views/components/dashboard/dashboard.component.html
// module id = 371
// module chunks = 1